import React from 'react';
import '../../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';
import { Link, withRouter } from 'react-router-dom';
import Footer from '../../includes/Footer';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Highlight from 'react-highlighter';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Search from '@material-ui/icons/Search';
import faqs from './FAQ';

class FaqPage extends React.Component {
  state = {
    search: '',
    expanded: false,
  };

  componentDidMount() {
    const activePanelId = this.props.location.search.split('=')[1];
    const activePanel = document.getElementById(activePanelId);

    if (activePanelId) {
      this.setState(
        {
          expanded: activePanelId,
        },
        () => {
          window.scrollTo({
            top: activePanel.offsetTop,
            behavior: 'smooth',
          });
        }
      );
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  handleSearchChange = e => {
    this.setState({ search: e.target.value });
  };

  handleExpandChange = panel => (event, isExpanded) => {
    this.props.history.push(`/faq?panel=${panel}`);
    this.setState({ expanded: isExpanded ? panel : false });
  };

  render() {
    const faqsList = faqs
      .filter(faq => {
        if (
          faq.question
            .toLowerCase()
            .includes(this.state.search.toLowerCase().trim()) ||
          faq.answer
            .toLowerCase()
            .includes(this.state.search.toLowerCase().trim())
        ) {
          return faq;
        }
      })
      .map((faq, index) => {
        return (
          <ExpansionPanel
            key={index}
            id={`panel-${index}`}
            expanded={this.state.expanded === `panel-${index}`}
            onChange={this.handleExpandChange(`panel-${index}`)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <b className="t-primary-16">
                {/* Highlight doesn't work with HTML content, fix later */}
                <Highlight
                  search={this.state.search.trim()}
                  matchClass={'search-highlight'}
                  dangerouslySetInnerHTML={{ __html: faq.question }}
                />
              </b>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <p className="t-secondary-16">
                {/* Highlight doesn't work with HTML content, fix later */}
                <Highlight
                  search={this.state.search.trim()}
                  matchClass={'search-highlight'}
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </p>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      });

    return (
      <React.Fragment>
        <div
          style={{
            maxWidth: '1024px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Grid
            spacing={0}
            container
            justify={'center'}
            spacing={0}
            className="template-terms "
          >
            <Grid
              item
              lg={12}
              md={7}
              sm={9}
              xs={10}
              className="u-pad-bot-30 info-main"
            >
              <span className="last-update">
                <span className="t-weight-b">Last update:</span> 07 March 2018
              </span>
              <h1 className="template-terms-main-title">
                Frequently asked questions
              </h1>
              <Grid
                spacing={0}
                container
                justify={'center'}
                spacing={0}
                className=""
              >
                <Grid item md={3} sm={12} className="w100 u-pad-r-10">
                  <span className="t-primary-20 t-weight-b">Stuck?</span>
                  <p className="t-primary-18 u-mrg-bot-10">
                    We are here for you
                  </p>
                  <p className="t-secondary-13 u-pad-r-40">
                    If you can not find the answer please submit a{' '}
                    <Link className="text-link-regular" to="/contact">
                      query
                    </Link>
                    .
                  </p>
                </Grid>
                <Grid item md={9} sm={12} className="w100">
                  <Grid spacing={0} container spacing={0} className="">
                    <Grid item xs={12} className="">
                      <p className="t-secondary-16 u-mrg-top-0">
                        Get instant answers for the most common questions.
                      </p>
                      <FormControl
                        fullWidth
                        className="u-mrg-top-20 u-mrg-bot-40"
                      >
                        <Input
                          startAdornment={
                            <InputAdornment
                              position="start"
                              classes={{ root: 'label--c-gray' }}
                            >
                              <Search />
                            </InputAdornment>
                          }
                          classes={{
                            underline: 'underline--c-black',
                          }}
                          id="search"
                          type="text"
                          label="Search"
                          value={this.state.search}
                          onChange={e => this.handleSearchChange(e)}
                        />
                      </FormControl>
                      {this.state.search && (
                        <p className="t-secondary-16 ">
                          {faqsList.length > 0
                            ? "Here's what we found for "
                            : 'No results for '}
                          <b className=".u-mrg-top-5">
                            <i>'{this.state.search.trim()}'</i>
                          </b>
                        </p>
                      )}
                      <div>{faqsList}</div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(FaqPage);
